import { withNamespaces } from "react-i18next";
import { Card, CardHeader, Table } from "reactstrap";

const MitigationTasks = ({ t, tasks, onMitigationTaskClicked }) => {
    if (!tasks?.length) return null;

    return (
        <Card
            outline
            body
            className='border border-primary rounded'
            style={{
                width: 'auto',
            }}
        >
            <CardHeader>{t('Risk Mitigation')}</CardHeader>

            <div
                style={{
                    maxHeight: '300px',
                    overflowY: 'auto'
                }}
            >
                <Table
                    responsive
                >
                    <thead>
                        <tr>
                            <th style={{width: '90px'}}>
                                {t('Task ID')}
                            </th>
                            <th>
                                {t('Task Title')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((task, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <span
                                            onClick={() => onMitigationTaskClicked && onMitigationTaskClicked(task.id)}
                                            className="btn-link"
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                        >
                                        {`T${task.secondary_id}`}
                                        </span>
                                    </td>
                                    <td>
                                        {task.name}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>

        </Card>
    )
}

export default withNamespaces()(
    MitigationTasks
);